var date = {};
module["exports"] = date;
date.month = require("./month");
date.weekday = require("./weekday");